import React from "react";
import { BsFillArrowUpSquareFill } from "react-icons/bs";
import ScrollToTop from "react-scroll-up";

function ScrollUp() {
  return (
    <ScrollToTop showUnder={100} style={{ right: 45, bottom: 50 }}>
      <BsFillArrowUpSquareFill className="w-8 h-8  bg-white rounded-full border-none" />
    </ScrollToTop>
  );
}

export default ScrollUp;
